var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 39.5834C6.25 45.5313 21.875 45.8334 25 45.8334C28.125 45.8334 43.75 45.5313 43.75 39.5834V10.4167C43.75 4.46883 28.125 4.16675 25 4.16675C21.875 4.16675 6.25 4.46883 6.25 10.4167V39.5834ZM25 8.33342C29.7636 8.10308 34.526 8.81093 39.0167 10.4167C34.526 12.0226 29.7636 12.7304 25 12.5001C20.2364 12.7304 15.474 12.0226 10.9833 10.4167C15.474 8.81093 20.2364 8.10308 25 8.33342ZM10.4167 14.6667C15.1477 16.0713 20.0655 16.7458 25 16.6667C29.9345 16.7458 34.8523 16.0713 39.5833 14.6667V24.6438C38.5292 25.5355 33.425 27.0834 25 27.0834C16.575 27.0834 11.4708 25.5355 10.4167 24.6438V14.6667ZM10.4167 29.2501C15.1477 30.6547 20.0655 31.3291 25 31.2501C29.9345 31.3291 34.8523 30.6547 39.5833 29.2501V39.2334C38.5042 40.1293 33.3958 41.6668 25 41.6668C16.6042 41.6668 11.4958 40.1293 10.4167 39.2334V29.2501Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustries);
export default __webpack_public_path__ + "static/media/industries.bbf6722c7c26bbb686c838f4f573bdd9.svg";
export { ForwardRef as ReactComponent };